<template>
  <div class="screenView">
    <div v-if="!modal">
      <span class="show-mobile navbar-container">
        <div id="hamburger" class="bar-item dropdown-click" @click="dropdownClick">
          <font-awesome-icon icon="bars"/>
        </div>
        <div id="dropdownMenu" class="dropdown-content bar-block" @click="dropdownClick">
          <router-link to="/" class="bar-item">
            <font-awesome-icon icon="home"/>
          </router-link>
          <router-link to="/tournaments" class="bar-item">{{ l('menu.tournaments') }}</router-link>
          <router-link to="/clubs" class="bar-item">{{ l('menu.clubs') }}</router-link>
          <router-link to="/persons" class="bar-item">{{ l('menu.chessPlayers') }}</router-link>

          <router-link to="/copyright" class="bar-item specialLink down">
            <font-awesome-icon icon="copyright"/>
            {{ l('footer.copyright') }}
          </router-link>
          
          <router-link to="/terms-of-service" class="bar-item specialLink">
            <font-awesome-icon icon="file-contract"/>
            {{ l('footer.termsAndConditions') }}
          </router-link>
          
          <router-link to="/privacy-statement" class="bar-item specialLink">
            <font-awesome-icon icon="lock"/>
            {{ l('footer.privacyStatement') }}
          </router-link>
          
          <router-link to="/contact" class="bar-item specialLink">
            <font-awesome-icon icon="envelope"/>
            {{ l('footer.contact') }}
          </router-link>
          
          <router-link to="/info/about" class="bar-item specialLink">
            <font-awesome-icon icon="info-circle"/>
            {{ l('footer.about') }}
          </router-link>
      </div>
        <div class="bar-item pushright" id="userDropdown">
          <user></user>
        </div>
      </span>

      <span class="navbar-container show-large">
        <router-link to="/" class="bar-item"><img src="./assets/img/CA_Logo_black.png" alt="Chess Administrator" class="logo-header"></router-link>
        <router-link to="/tournaments" class="bar-item">{{ l('menu.tournaments') }}</router-link>
        <router-link to="/clubs" class="bar-item">{{ l('menu.clubs') }}</router-link>
        <router-link to="/persons" class="bar-item">{{ l('menu.chessPlayers') }}</router-link>
        <a href="https://chess-administrator.myspreadshop.nl/" class="bar-item merch-link" target="_blank" >{{ l('menu.merchandise') }}</a>
        <div class="bar-item pushright" id="userDropdown">
          <user></user>
        </div>
      </span>
    </div>

    <div id="mainview" class="mainView">
      <router-view></router-view>
    </div>

    <div class="bar footer" v-if="!modal">
      <div class="footerlinks">
        <router-link to="/copyright" class="footerLink specialLink">
          <font-awesome-icon icon="copyright"/>
          {{ l('footer.copyright') }}
        </router-link>
        -
        <router-link to="/terms-of-service" class="footerLink specialLink">
          <font-awesome-icon icon="file-contract"/>
          {{ l('footer.termsAndConditions') }}
        </router-link>
        -
        <router-link to="/privacy-statement" class="footerLink specialLink">
          <font-awesome-icon icon="lock"/>
          {{ l('footer.privacyStatement') }}
        </router-link>
        -
        <router-link to="/contact" class="footerLink specialLink">
          <font-awesome-icon icon="envelope"/>
          {{ l('footer.contact') }}
        </router-link>
        -
        <router-link to="/info/about" class="footerLink specialLink">
          <font-awesome-icon icon="info-circle"/>
          {{ l('footer.about') }}
        </router-link>
      </div>

      <div class="footerLink">
        <img id="nl" :class="{'inactive bar-item': showLanguageNL }" class="countryFlag" src="./locale/flags/NL.svg" @click="setLanguage('nl')" />
        <img id="en" :class="{'inactive bar-item': showLanguageEN }" class="countryFlag" src="./locale/flags/GB-UKM.svg" @click="setLanguage('en')" />
      </div>
      <div class="version">Bastion: {{ connectionStatus }}, <router-link to="/info/version" class="footerLink specialLink"> version: 1.0.1 </router-link></div>
    </div> 
  </div>
</template>

<script>

import User from "@/components/users/User";
import {RestAPI} from "@aws-amplify/api-rest";

const apiName = 'api';
const listPath = '/status';
const myInit = { 
  response: true, 
};


export default {
  name: 'App',
  components: {User}, 
  data: function() {
    return {
      knightC: require('./assets/img/knight2_small.png'),
      backgroundKnight: {
        backgroundImage: 'url(' + require('./assets/img/KnightLeft.png') + ')',
        'background-size': '22px',
        'background-repeat': 'no-repeat',
        'background-position': '4px 4px'
      },
      snowKnight: {
        backgroundImage: 'url(' + require('./assets/img/KnightSnow.png') + ')',
        'background-size': '30px',
        'background-repeat': 'no-repeat',
        'background-position': '0px 4px'
      },
      connectionStatus: "checking...",
      interval: null,
      latestActivity: null,
      locale: "",
      sessionCheckInMinutes: 12,
      try: 0
    }
  },
  computed: {
    isHomepage: function () {
      return this.$route.path == '/';
    },
    loggedIn: function () {
      return this.$CAUser.loggedIn();
    },
    modal: function () {
      return (this.$route.path == '/sign-up') || 
             (this.$route.path == '/sign-in') || 
             (this.$route.path == '/info/about') || 
             (this.$route.path == '/password-reset') || 
             (this.$route.path == '/select-user') || 
             (this.$route.path == '/email-confirmation') || 
             (this.$route.path == '/reset-password-request') ||
             (this.$route.query.modal == "yes") ||
             (this.$route.query.framed == "yes");
    },
    seasonLogo: function() {
      var today = new Date();
      console.log('month: ' +today.getMonth());
      if (today.getMonth() == 11) {
        return this.snowKnight;
      } else
      {
        return this.backgroundKnight;
      }                           
    },
    showLanguageNL: function() {
      console.log('checking NL');
      return ('nl' != this.locale);
    },
    showLanguageEN: function() {
      return ('en' != this.locale);
    }
  },
  mounted() {
    this.determineConnectionStatus();
    this.determineUserLocale();
    this.determineTheme();
    console.log("Starting... ");
    console.log("API_URL: " + process.env.VUE_APP_APIURL);

    // this will check the latest activity every 60 seconds
    /* Removed after adding Refresh token functionality.
    this.interval = setInterval(() => {
        this.checkSessionActivity();
      }, 60000); // every 60 seconds
    */
    /* Procedure to close the dropdown menu when the user clicked outside of the menu */
    document.addEventListener("click", (evt) => {
      this.setActivityTime();
      const flyoutEl = document.getElementById("dropdownMenu");
      const hamburgerEl = document.getElementById("hamburger");
      const userEl = document.getElementById("userDropdown");
      let targetEl = evt.target; // clicked element
      do {
        if ((targetEl == flyoutEl) || (targetEl == hamburgerEl ||targetEl == userEl )) {
          return; // This is a click inside, does nothing, just return.
        }
        targetEl = targetEl.parentNode; // Go up the DOM
      } while (targetEl);

      // This is a click outside.
      if (flyoutEl != null) {
        if (flyoutEl.className.indexOf("show") !== -1) {
          flyoutEl.className = flyoutEl.className.replace(" show", "");
        }
      }
      if (userEl != null) {
        if (userEl.className.indexOf("show") !== -1) {
          userEl.className = userEl.className.replace(" show", "");
        }
      }
    });
  },
  methods: {
    checkSessionActivity() {
      // follows user activity at a certain interval.
      // after "sessionCheckInMinutes" we check the latestActivity.
      // after 10 minutes of inactivity, perform a call to keep the session alive.

      var today = new Date()
      var now_minutes = today.getHours()*60 + today.getMinutes()
      if (this.latestActivity == null) {
        this.latestActivity = now_minutes;
      }
      var minutesOfInactivity = now_minutes - this.latestActivity;
      console.log("=== check activity at " + minutesOfInactivity.toString() + " ===")
      if (minutesOfInactivity >= this.sessionCheckInMinutes) {
        console.log("=== refresh connection ===")
        this.determineConnectionStatus();
        this.latestActivity = now_minutes;
      }
    },
    
    determineConnectionStatus() {
      let that = this
      RestAPI
        .get(apiName, listPath, myInit)
        .then(response => {that.connectionStatus = response.data.message; 
          console.log("Connection status: " + that.connectionStatus);
        })
        .catch(error => {
          that.try = that.try + 1;
          that.connectionStatus = "not connected yet, try " + that.try.toString();
          console.log(error);
          if (that.try < 4)
            that.determineConnectionStatus();
        });

    },

    determineTheme() {
      var theme = localStorage.getItem("theme");
      console.log('theme from localstorage: ' + theme);
      if (theme == null || theme == "undefined") {
        theme = "theme_dark";
      }
      this.setTheme(theme);
    },

    determineUserLocale() {
      var lang = localStorage.getItem("locale");
      console.log('locale from localstorage: ' + lang);
      if (lang == null) {
        lang  = this.getLocale();
        console.log('locale from browser: ' + lang);
      }

      this.locale = lang;
      this.$i18n.locale = lang; 
    },

    dropdownClick() {
      var y = document.getElementById("mainview");
      if (y.className.indexOf("blur") == -1) {
        y.className += " blur";
      } else {
        y.className = y.className.replace(" blur", "");
      }

      var x = document.getElementById("dropdownMenu");
      if (x.className.indexOf("show") == -1) {
        x.className += " show";
      } else {
        x.className = x.className.replace(" show", "");
      }
    },
    
    getLocale() {
      return this.getNavigatorLanguage().substring(0,2);
    },

    getNavigatorLanguage() {
      if (navigator.languages && navigator.languages.length) {
        return navigator.languages[0];
      } else {
        return navigator.userLanguage || navigator.language || navigator.browserLanguage || 'nl';
      }
    },

    l(text) {
      return this.$t('app.' + text)
    },

    setActivityTime() {
      // updates the latest time of inactivity, so this will be taken into account when 
      // renewing the session.
      var today = new Date()
      var now_minutes = today.getHours()*60 + today.getMinutes()
      this.latestActivity = now_minutes;
    },

    setLanguage(lang) {
      this.locale = lang;
      this.$i18n.locale = lang; 
      localStorage.setItem("locale", lang);
    },

    setTheme(theme) {
      document.body.classList.replace("theme_white", theme); 
    },
  }
}

</script>

<style scoped>


.countryFlag {
  padding: 4px;
}

.dropdown-click {
  position: relative;
  cursor: pointer;
}

.down {
    margin-top: auto;
}

.footer {
  display: flex;
  justify-content: center;
  padding: 5px;
  flex-wrap: wrap;
  align-items: center;
  gap: 5px;
}

.footerLink {
  margin-left: 5px;
  margin-right: 5px;
  white-space: nowrap;
  flex-shrink: 0;
}

.footerLink:hover {
  text-decoration: underline;
}

.hamburger:focus {
  outline: none;
  background-color: #fff !important;
}

.hamburger:hover {
  color: #eef2f9 !important;
  background-color: #111d2f !important;
}

.dropdown-content {
  display: none;
  flex-direction: column;
  cursor: auto;
  position: absolute;
  background-color: #363636;
  transition: opacity 0.5s linear;
  min-width: 160px;
  height: calc(100vh - 72px);
  top: 40px;
  left: 12px;
  box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
  padding: 12px 16px;
  z-index: 1;
  /* duration | timing-function | delay | iteration-count | direction | fill-mode */
  animation: slideInLeft 0.5s ease-out forwards;
}

@keyframes slideInLeft {
  from {
    transform: translateX(-100%); /* Start completely off-screen to the left */
    opacity: 0;                   /* Optional: fade in while sliding */
  }
  to {
    transform: translateX(0);     /* End at its original position */
    opacity: 1;
  }
}

.inactive {
  opacity: 0.4;  
}

.inactive:hover {
  opacity: 1;  
}

.logoContainer {
  position: relative;
  padding-left: 10px;
}

.mainView {
  display:flex;
  flex-direction: column;
  flex-grow: 1;
  margin: auto;
  min-height: calc(100vh - 97px); /*complete view, minus menu and footer*/
  width: 100%;
}

.screenView {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  color: #E5E5E5; /* Lichte tekstkleur */
}

.merch-link {
  flex-grow: 1;
  margin-left:auto;
  justify-self: flex-end;
  text-align: right;
  margin-right: 5vw;

/* Define golden gradient as background */
  background-image: linear-gradient(135deg, #bf953f, #fcf6ba, #b38728, #fbf5b7, #aa771c);
  /* Cut the background in the shape of the text */
  -webkit-background-clip: text;
  background-clip: text;
  /* Make the original text transparent */
  -webkit-text-fill-color: transparent;
  /* Fallback */
  color: #b38728;  
}

.merch-link:hover {
  background-image: linear-gradient(75deg, #b38728, #fbf5b7, #aa771c, #bf953f, #fcf6ba);
}

.version {
  color: #72777e;
  font-size: 0.85em;
}

/* mobile */
@media screen and (max-width: 600px) {
  .show-mobile {
    display:flex;
  }

  .show-large {
    display: none;
  }

  .footer {
    flex-direction: row;
    font-size: 0.9em;
  }

  .footerLink {
    margin: 2px 0;
  }

  .footerlinks {
    display: none;
  }
  
  .blur {
    opacity: 0.5;
  }

  .version {
    float: none;
    text-align: center;
    margin-top: 5px;
    font-size: 0.75em;
  }

  .rightMenu {
    align-self: center;
    margin-top: 5px;
  }

  .navbar-container {
    box-shadow:none;
  }
}

/* ipad */
@media screen and (min-width: 601px) and (max-width: 1280px) {
  .show-mobile {
    display: none;
  }

  .show-large {
    display: flex;
    flex-grow: 1;
  }
}

/* laptop */
@media screen and (min-width: 1281px) {
  .show-mobile {
    display: none;
  }

  .show-large {
    display: flex;
    flex-grow: 1;
  }
}
</style>